import {pageInfo, initUpdate, planVehicleUpLoad, exportData, template, cancleSubmit, adjustSchSeqSubmit, initDestStorageUpdate, destStorageEditSubmit, getPlantTimeRangeOfOneDay} from "../api";
import {businessType, goodsCategory, plant, selectReshipLoadingType, storageList} from "../../../../../api";
const reshipCornPlanVehicle = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initUpdateObj: null,
    planVehicleUploadObj: null,
    exportObj: null,
    templateObj: null,
    cancleObj: null,
    plantCodeObj: null,
    goodesCategoryCodeObj: null,
    storageCodeObj: null,
    loadingTypeCodeDataObj: null,
    businessTypeObj: null,
    adjustSchSeqObj: null,
    updateDestInitObj: null,
    destStorageEditObj: null,
    plantTimeRangeOfOneDayObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj.map(item=>({...item, btns:[{disabled: item.updateButtonShow !='Y' ? true : false},true,{disabled: item.schStatusCode !='00' ? true : false}]})) || [];
    },
    UPDATE_INIT_DATA(state, data){
      state.initUpdateObj = data;
    },
    PLAN_VEHICLE_UPLOAD_DATA(state, data){
      state.planVehicleUploadObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    CANCLE_DATA(state, data) {
      state.cancleObj = data;
    },
    PLANT_CODE_DATA(state, data){
      state.plantCodeObj = data;
    },
    GOODS_CATEGORY_CODE_DATA(state, data){
      state.goodesCategoryCodeObj = data;
    },
    STORAGE_CODE_DATA(state, data){
      state.storageCodeObj = data;
    },
    LOADING_TYPE_CODE_DATA(state, data){
      state.loadingTypeCodeDataObj = data;
    },
    BUSINESS_TYPE_DATA(state, data){
      state.businessTypeObj = data;
    },
    ADJUST_SCH_SEQ_DATA(state, data){
      state.adjustSchSeqObj = data;
    },
    DEST_UPDATE_INIT_DATA(state, data){
      state.updateDestInitObj = data.obj;
    },
    DEST_STORAGE_EDIT_DATA(state, data){
      state.destStorageEditObj = data;
    },
    PLANT_TIME_RANGE(state, data){
      state.plantTimeRangeOfOneDayObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //修改初始化
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('UPDATE_INIT_DATA', resp);
    },
    //运作单流程详情
    async getShipWorkFlowLog({ commit }, obj) {
      let resp = await getWorkFlowLog(obj);
      commit('GET_SHIP_WORK_FLOW_LOG', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //导入数据
    async planVehicleUpLoad({ commit }, obj) {
      let resp = await planVehicleUpLoad(obj);
      commit('PLAN_VEHICLE_UPLOAD_DATA', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await template(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //取消提交
    async cancleSubmit({ commit }, obj) {
      let resp = await cancleSubmit(obj);
      commit('CANCLE_DATA', resp);
    },

    //基地
    async getPlantCodeList({ commit }, obj) {
      let resp = await plant(obj);
      commit('PLANT_CODE_DATA', resp);
    },
    //货物类型
    async getGoodsCategoryCodeList({ commit }, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY_CODE_DATA', resp);
    },
    //发出库位
    async getStorageCodeList({ commit }, obj) {
      let resp = await storageList(obj);
      commit('STORAGE_CODE_DATA', resp);
    },
    //装货类型
    async getLoadingTypeCodeList({ commit }, obj) {
      let resp = await selectReshipLoadingType(obj);
      commit('LOADING_TYPE_CODE_DATA', resp);
    },
    //业务类型
    async getBusinessTypeList({ commit }, obj) {
      let resp = await businessType(obj);
      commit('BUSINESS_TYPE_DATA', resp);
    },
    //玉米倒运顺序调整提交
    async adjustSchSeqSubmit({ commit }, obj) {
      let resp = await adjustSchSeqSubmit(obj);
      commit('ADJUST_SCH_SEQ_DATA', resp);
    },
    //库位调整修改初始化
    async initDestStorageUpdate({ commit }, obj) {
      let resp = await initDestStorageUpdate(obj);
      commit('DEST_UPDATE_INIT_DATA', resp);
    },
    async destStorageEditSubmit({ commit }, obj) {
      let resp = await destStorageEditSubmit(obj);
      commit('DEST_STORAGE_EDIT_DATA', resp);
    },
    async getPlantTimeRangeOfOneDay({ commit }, obj) {
      let resp = await getPlantTimeRangeOfOneDay(obj);
      commit('PLANT_TIME_RANGE', resp);
    },
  }
}
export default reshipCornPlanVehicle



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornPlanVehicle/store/reshipCornPlanVehicle.store.js